import { useMemo } from "react";
import { encode } from "uqr";
import s from "./share.module.css";

/** Four modules of blank field around the code, as the QR spec asks for. */
const QUIET = 4;

/**
 * One SVG path, one module per unit. Crisp at any size and printable from a
 * screenshot; the plate keeps dark-on-light in both themes so every scanner reads it.
 */
export function QrCode({ value, label }: { value: string; label: string }) {
  const { path, size } = useMemo(() => {
    const qr = encode(value, { ecc: "M", border: 0 });
    let d = "";
    qr.data.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { path: d, size: qr.size };
  }, [value]);

  return (
    <svg
      className={s.qr}
      viewBox={`${-QUIET} ${-QUIET} ${size + QUIET * 2} ${size + QUIET * 2}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect
        x={-QUIET}
        y={-QUIET}
        width={size + QUIET * 2}
        height={size + QUIET * 2}
        fill="var(--qr-paper)"
      />
      <path d={path} fill="var(--qr-ink)" />
    </svg>
  );
}
